var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExitFullScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29402 3.76436C3.55392 3.76436 3.76461 3.55367 3.76461 3.29377L3.76461 1.41142C3.76461 0.631724 4.39667 -0.000344945 5.17637 -0.000344877C5.95607 -0.000344809 6.58814 0.631724 6.58814 1.41142L6.58814 3.29377C6.58813 5.11306 5.11331 6.58789 3.29402 6.58789L1.41166 6.58789C0.631968 6.58789 -0.000100557 5.95582 -0.000100489 5.17613C-0.000100421 4.39643 0.631968 3.76436 1.41166 3.76436L3.29402 3.76436Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7055 3.76436C12.4456 3.76436 12.2349 3.55367 12.2349 3.29377L12.2349 1.41142C12.2349 0.631724 11.6028 -0.00034437 10.8231 -0.000344506C10.0434 -0.000344643 9.41138 0.631724 9.41138 1.41142L9.41138 3.29377C9.41138 5.11306 10.8862 6.58789 12.7055 6.58789L14.5878 6.58789C15.3675 6.58789 15.9996 5.95582 15.9996 5.17613C15.9996 4.39643 15.3675 3.76436 14.5878 3.76436L12.7055 3.76436Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29402 11.7649C3.55391 11.7649 3.76461 11.9756 3.7646 12.2355L3.7646 14.5885C3.7646 15.3682 4.39667 16.0002 5.17637 16.0002C5.95607 16.0002 6.58813 15.3682 6.58813 14.5885L6.58813 12.2355C6.58813 10.4162 5.11331 8.94141 3.29402 8.94141L1.41166 8.94141C0.631968 8.94141 -0.000100668 9.57347 -0.000100736 10.3532C-0.000100804 11.1329 0.631968 11.7649 1.41166 11.7649L3.29402 11.7649Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7055 12.2356C12.4456 12.2356 12.2349 12.4463 12.2349 12.7062L12.2349 14.5886C12.2349 15.3683 11.6028 16.0003 10.8231 16.0003C10.0434 16.0003 9.41138 15.3683 9.41138 14.5886L9.41138 12.7062C9.41138 10.8869 10.8862 9.41211 12.7055 9.41211L14.5878 9.41211C15.3675 9.41211 15.9996 10.0442 15.9996 10.8239C15.9996 11.6036 15.3675 12.2356 14.5878 12.2356L12.7055 12.2356Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullScreen);
export default __webpack_public_path__ + "static/media/exitFullScreen.7a746e82d8f3c36b13c2d8330f01a45f.svg";
export { ForwardRef as ReactComponent };